import React, { FC } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../design-system/breakpoints';
import { UserInfo } from '../../../common/model/dto/user-info';
import StringUtils from '../../../common/utils/services/string-utils';

const OvPrettyUserName: FC<{
  user?: UserInfo;
  options?: { readSafe: boolean };
}> = ({ user, options }) => {
  const prettyUserName = StringUtils.getPrettyUserName(user, options);

  return (
    <>
      {prettyUserName}
      <br />
      {!options?.readSafe && (
        <Email>{prettyUserName ? ` (${user?.email})` : user?.email}</Email>
      )}
    </>
  );
};

export default OvPrettyUserName;

const Email = styled.div`
  white-space: nowrap;

  @media (max-width: ${breakpoints.lg}) {
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;
